import React from 'react';
import { connect } from 'react-redux';
import ControlService from '../../helper/controlservice';
import { resetFormData, updateData } from "../actions";
import If from '../../helper/component/If'
import { extractErrorMessage } from '../Button/_private';

const mapStateToProps = state => ({
  data: state.formDataReducer,
  hasErrored: state.formDataReducer.hasErrored,
  isLoading: state.formDataReducer.isLoading,
});
function bindAction(dispatch) {
  return {
    update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
    resetData: (data, storekey) => dispatch(resetFormData(data, storekey)),
  };
}
class FormWizard extends React.PureComponent {
  state = {
    activeTabIndex: 0,
    LastIndex: 0,
    IsComplete: false,
    activePanelIndex: [],
    nextstepaction: null,
    backstepaction: null
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    var data = nextProps.data[nextProps.formid + 'write'] ? nextProps.data[nextProps.formid + 'write'] : {}
    if (data && data[nextProps.control.key + '_next'] != prevState.nextstepaction) {
      return {
        nextstepaction: data[nextProps.control.key + '_next'],
      };
    } else if (data && data[nextProps.control.key + '_back'] != prevState.backstepaction) {
      return {
        backstepaction: data[nextProps.control.key + '_back'],
      };
    } else return null; // Triggers no change in the state
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.nextstepaction && prevState.nextstepaction != this.state.nextstepaction) {
      this.SetTabindex('Next');
    } else if (this.state.backstepaction && prevState.backstepaction != this.state.backstepaction) {
      this.SetTabindex('Prev');
    }
  }

  tabChange(id, tab) {
    debugger;
    this.setState({ LastIndex: this.props.control.children.length - 1 });
    if (id == this.state.activeTabIndex + 1 || tab.enabled == true) {
      this.setState({ IsComplete: false })
      this.setState({ activeTabIndex: id })

    }
    //window.scrollTo(0, 0)
  }
  panelChange(i, tab) {

    var activePanelIndex = this.state.activePanelIndex;
    if (activePanelIndex[i] == null)
      activePanelIndex[i] = tab;
    else
      activePanelIndex[i] = null;

    this.setState({ activePanelIndex: activePanelIndex });
  }
  SetTabindex(type) {
    debugger;
    if (this.validateForm(type) || type == "Prev") {
      this.setState({ LastIndex: this.props.control.children.length - 1 });
      var activeTabIndex = this.state.activeTabIndex;
      if (type == "Next") {
        this.setState({ activeTabIndex: (activeTabIndex + 1) });
      } else {
        this.setState({ activeTabIndex: (activeTabIndex - 1) });
      }
      var s = document.getElementById(this.props.control.id);
      if (s)
        window.scrollTo(0, s.offsetTop)
    }
  }
  GetClass(id) {
    return this.state.activeTabIndex == id ? 'tab-pane active' : 'tab-pane';
  }
  SidebarChange(id) {
    if (this.validateForm() || id < this.state.activeTabIndex) {
      this.setState({ activeTabIndex: id, LastIndex: this.props.control.children.length - 1 });
    }
  }
  validateForm(type) {
    debugger;
    var valid = true;
    const { control, formid, action } = this.props;
    if (control.enablestepvalidation) {
      var mandatoryCtrl = [];
      var data = this.props.data[this.props.formid + this.props.action];
      data = data ? data : {};
      // This function deals with validation of the form fields
      var currentTab = control.children[this.state.activeTabIndex];
      for (let key in data) {
        let __control = ControlService().find(currentTab.children, key, 'key');
        if (__control && __control.require) {
          mandatoryCtrl.push(__control)
        }
      }
      if (mandatoryCtrl.length > 0) {
        var formvalidation = this.props.data[formid + action + "_validation"]
        if (type === 'Prev') {
          mandatoryCtrl.forEach(element => {
            delete formvalidation[element.key];
          });
          this.props.resetData(formvalidation, formid + action + "_validation");
        } else {
          let InValidControls = [];
          // Object.keys(formvalidation).forEach(
          //   (key) => {
          //     const value = formvalidation[key] ? formvalidation[key] : {};
          //     let _control = mandatoryCtrl.find(x => x.key == key);
          //     if (_control && value.status == 'fail') {
          //       InValidControls.push(formvalidation[key]);
          //       valid = false;
          //       this.props.update(_control.key, { "status": "fail", "control": _control, touched: true }, this.props.formid + action + "_validation");
          //     }
          //   });
          mandatoryCtrl.forEach(__control => {
            if (__control.require) {
              var _data = data[__control.key];
              var validation = ControlService().validate(__control, _data);
              if (validation) {
                this.props.update(__control.key, { "status": "pass", "control": __control, touched: false }, formid + "_validation")
              } else {
                InValidControls.push({ control: __control });
                valid = false;
                this.props.update(__control.key, { "status": "fail", "control": __control, touched: false }, formid + "_validation")
              }
            }
          });
          if (control.showValidationSummary && InValidControls.length > 0) {
            let message = extractErrorMessage(InValidControls)
            ControlService().toastError(message, 'Errors found in the form')
            return;
          }
        }
      }
    }
    return valid; // return the valid status
  }
  GetTabClass(item, id) {
    var _class = '';
    if (item.enabled == true && this.state.IsComplete == true && this.state.LastIndex == id)
      _class = 'enabled';
    else if ((this.state.LastIndex == id && this.state.IsComplete == true) || this.state.activeTabIndex == id) {
      item.enabled = true;
      _class = 'text-' + item.activetabtextcolor + ' active bg-' + item.activetabbg;
    } else if (this.state.activeTabIndex > id) {
      item.enabled = true;
      _class = 'completed';
    } else if (item.enabled == true) {
      _class = 'completed';
    } else {
      _class = 'nav-item';
    }
    return _class;
  }
  render() {
    const { control, action, formid } = this.props;
    const { activeTabIndex, LastIndex, IsComplete } = this.state;
    var tabCounts = [];
    for (let i = 1; i < control.children.length + 1; i++) {
      tabCounts.push(
        <span key={i} style={{ width: 20, height: 20, lineHeight: 20, borderRadius: 10, fontSize: 11, textAlign: 'center' }}>
          {i}
        </span>
      )
    }
    const nextBackButton = (withProgressbar) => {
      return (
        <React.Fragment>
          {(activeTabIndex > 0 && activeTabIndex < LastIndex) && (!control.hidenextbutton || !control.hidebackbutton) &&
            <div className={"d-flex  " + (withProgressbar ? ' ' : ' mb-3 ') + (control.buttonposition ? control.buttonposition : 'justify-content-between')}>
              {!control.hidebackbutton &&
                <button aria-label='Back' type="button" className={" btn  " + (control.backbuttonsize ? control.backbuttonsize : ' ') + " " + (control.backcustomClass) + " " + (control.backbuttontype ? control.backbuttontype : 'btn-outline-primary')} onClick={(e) => { e.preventDefault(); this.SetTabindex('Prev') }}>
                  {control.backbuttonicon && <i className={"fa  " + (control.backbuttontext ? ' pr-2 ' : '') + control.backbuttonicon}></i>}
                  {control.backbuttontext ?
                    control.backbuttontext
                    :
                    <React.Fragment>
                      <i className={"fa  pr-2 " + (control.backbuttonicon ? control.backbuttonicon : 'fa-arrow-left')}></i> {activeTabIndex}. {control.children[activeTabIndex - 1].Header}
                    </React.Fragment>
                  }
                </button>
              }
              {!control.hidenextbutton &&
                <button aria-label='Next' type="button" onClick={(e) => { e.preventDefault(); this.SetTabindex('Next') }} className={" btn " + (control.nextbuttonsize ? control.nextbuttonsize : ' ') + " " + (control.nextcustomClass) + " " + (control.nextbuttontype ? control.nextbuttontype : 'btn-outline-primary')}>

                  {control.nextbuttontext ?
                    control.nextbuttontext
                    :
                    <React.Fragment>
                      {activeTabIndex + 2}. {control.children[activeTabIndex + 1].Header}<i className={"fa pl-2 " + (control.nextbuttonicon ? control.nextbuttonicon : 'fa-arrow-right')}></i>
                    </React.Fragment>
                  }
                  {control.nextbuttonicon && <i className={"fa  " + (control.nextbuttontext ? ' pl-2 ' : '') + control.nextbuttonicon}></i>}
                </button>
              }
            </div>
          }
          {!control.hidenextbutton && activeTabIndex == 0 &&
            <div className={"d-flex " + (withProgressbar ? ' ' : ' mb-3 ') + ((control.buttonposition == 'justify-content-between' || !control.buttonposition) ? 'justify-content-end' : control.buttonposition)}>

              <button aria-label='Next' type="button" onClick={(e) => { e.preventDefault(); this.SetTabindex('Next') }} className={" btn " + (control.nextbuttonsize ? control.nextbuttonsize : ' ') + " " + (control.nextcustomClass) + " " + (control.nextbuttontype ? control.nextbuttontype : 'btn-outline-primary')}>
                {control.nextbuttontext ?
                  control.nextbuttontext
                  :
                  <React.Fragment>
                    {activeTabIndex + 2}. {control.children[activeTabIndex + 1].Header}<i className={"fa pl-2 " + (control.nextbuttonicon ? control.nextbuttonicon : 'fa-arrow-right')}></i>
                  </React.Fragment>
                }
                {control.nextbuttonicon && <i className={"fa  " + (control.nextbuttontext ? ' pl-2 ' : '') + control.nextbuttonicon}></i>}
              </button>
            </div>
          }
          {!control.hidebackbutton && (activeTabIndex > 0 && activeTabIndex == LastIndex) &&
            <div className={"d-flex " + (withProgressbar ? ' ' : ' mb-3 ') + (control.buttonposition ? control.buttonposition : 'justify-content-start')}>
              <button aria-label='Back' type="button" className={" btn " + (control.backbuttonsize ? control.backbuttonsize : ' ') + " " + (control.backcustomClass) + " " + (control.backbuttontype ? control.backbuttontype : 'btn-outline-primary')} onClick={(e) => { e.preventDefault(); this.SetTabindex('Prev') }}>
                {control.backbuttonicon && <i className={"fa  " + (control.backbuttontext ? ' pr-2 ' : '') + control.backbuttonicon}></i>}
                {control.backbuttontext ?
                  control.backbuttontext
                  :
                  <React.Fragment>
                    <i className={"fa  pr-2 " + (control.backbuttonicon ? control.backbuttonicon : 'fa-arrow-left')}></i> {activeTabIndex}. {control.children[activeTabIndex - 1].Header}
                  </React.Fragment>
                }
              </button>
            </div>
          }
        </React.Fragment>
      )
    };
    var wizardnawitems = control.children.map((tab, index) => {
      if (!control.position || control.position == 'left') {
        return (
          // <div key={tab.Header} heading={tab.Header}>
          <li onClick={(e) => { e.preventDefault(); this.SidebarChange(index) }} key={tab.id} className={"step d-flex pointer " + (activeTabIndex == index ? ' active' : "") + " " + (activeTabIndex > index ? ' completed' : "") + ' ' + this.GetTabClass(tab, index)}>
            {activeTabIndex == index && control.children.length != index + 1 &&
              <span className={"tab-line bg-" + tab.activetabbg}></span>
            }
            {activeTabIndex != index && control.children.length != index + 1 &&
              <span className={"tab-line " + control.linecolor}></span>
            }
            {activeTabIndex == index &&
              <span className={"step-icon bg-" + tab.iconcolor + " text-" + tab.activetabbg}>{index + 1}</span>
            }
            {activeTabIndex != index &&
              <span className={"step-icon bg-" + tab.iconcolor}>{index + 1}</span>
            }
            <div className="step-title" >
              <span>{tab.Header}</span>
              <small className="d-block">{tab.subHeader}</small>
            </div>
          </li>
        )
      } else if (control.position == 'top' || control.position == 'bottom') {
        return (
          <li key={tab.id} className={(activeTabIndex == index ? ' active' : "") + " " + (activeTabIndex > index ? ' completed' : "")} data-step={index + 1}>
            <button className={"pointer btn-no"}
              id={tab.id} data-toggle="tab" role="tab"
              // onClick={(e) => {
              //   e.preventDefault();
              //   this.tabChange(index, tab)
              // }}
              onClick={(e) => {e.preventDefault();this.SidebarChange(index)}}
              >
              <span className={'stap-no'}>
                <If show={activeTabIndex > index}>
                  <i className="fa fa-check"></i>
                </If>
                <If show={activeTabIndex <= index}>
                  {index + 1}
                </If>
              </span>
              <span className="d-block text-center">{tab.Header}</span>
              <small className="d-block text-center">{tab.subHeader}</small>
            </button>
          </li>
        )
      } else {
        return (
          // <div key={tab.Header} heading={tab.Header}>
          <li key={tab.id} className={((control.position == 'top' || control.position == 'bottom' || control.position == 'sidebar') ? 'nav-item' : 'step') + " " + (activeTabIndex == index ? ' active' : "") + " " + (activeTabIndex > index ? ' completed' : "")} data-step={index + 1}>
            {(control.position == 'top' || control.position == 'bottom' || control.position == 'sidebar') &&

              <button className={"nav-link pointer " + (activeTabIndex == index ? 'active' : '') + " " + this.GetTabClass(tab, index)}
                id={tab.id} data-toggle="tab" role="tab"
                // onClick={(e) => {
                //   e.preventDefault();
                //   this.tabChange(index, tab)
                // }}
                onClick={(e) => {e.preventDefault();this.SidebarChange(index)}}
                >
                {(activeTabIndex >= index && control.children.length != index + 1) && <span className={"tab-line bg-" + tab.activetabbg}></span>}
                {(activeTabIndex != index && control.children.length != index + 1) && <span className={"tab-line " + control.linecolor}></span>}
                {tab.tabicon && <i className={"fa-lg step-icon " + tab.tabiconSize + " " + tab.tabicon + " bg-" + tab.iconcolor}></i>}
                {tab.tabicon && <i className={"fa-lg step-icon step-icon-active " + tab.tabicon + " bg-" + tab.iconcolor + " text-" + tab.activetabbg}></i>}
                <span className="d-block text-center">{tab.Header}</span>
                <small className="d-block text-center">{tab.subHeader}</small>
                {tab.tabicon && <span className={"active-arrow bottom-arrow border-" + tab.activetabbg}></span>}
              </button>
            }
          </li>
        )
      }
    })

    return (
      <React.Fragment>
        {control.stylecss &&
        <style>
          {control.stylecss}
        </style>
        }
        {(!control.position || control.position == 'left') ?
          <div className={'wizard wizard-left'}>
            <div className="row">
              <div className={" py-2 " + (control.navbg ? control.navbg : 'bg-light') + " " + (control.sidebarWidth ? (control.sidebarWidth == 'auto' ? 'col-auto' : ('col-md-' + control.sidebarWidth)) : 'col-md-3')}>
                <div className="wizard-sidebar">
                  <ul className="wizard-left-ul steps" role="tablist">
                    {wizardnawitems}
                  </ul>
                </div>
              </div>
              <div className={(control.sidebarWidth ? (control.sidebarWidth == 'auto' ? 'col' : ('col-md-' + (12 - control.sidebarWidth))) : 'col-md-9')}>
                <form role="form">
                  <div className="tab-content">
                    {control.children.map((tab, i) => {
                      return (
                        <div key={tab.id} hidden={IsComplete} className={this.GetClass(i)} id={tab.key} role="tabpanel">
                          <div className="row">
                            <div className="col-md-12">
                              {control.buttonplacing == 'top' && nextBackButton()}
                              {tab.label ? <h4 className="text-primary">{tab.label}</h4> : ''}
                              {!control.enablestepvalidation ?
                                <div className="row mb-3" style={{ 'display': activeTabIndex == i ? '' : 'none' }}>
                                  {
                                    tab.children.map((ch) => {
                                      return (
                                        ControlService().renderControls(ch, action, formid)
                                      )
                                    })
                                  }
                                </div>
                                : activeTabIndex == i ?
                                  <div className="row mb-3">
                                    {
                                      tab.children.map((ch) => {
                                        return (
                                          ControlService().renderControls(ch, action, formid)
                                        )
                                      })
                                    }
                                  </div>
                                  : null
                              }
                              {control.buttonplacing != 'top' && nextBackButton()}
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </form>
              </div>
            </div>
          </div>
          : (control.position == 'progressbar') ?

            <div className="progressbar" id={this.props.control.id}>
              <div className='row align-items-center mx-0 mb-3' style={{ minHeight: 41 }}>
                {control.buttonplacing == 'top' &&
                  <div className='col-auto' style={{ padding: 3, }}>
                    {nextBackButton(true)}
                  </div>
                }
                <div className='col p-0'>
                  <div className="progress" style={{ height: 3 }}>
                    <div className="progress-bar" role="progressbar" style={{ width: (activeTabIndex ? (100 / LastIndex) * activeTabIndex : 0) + '%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              </div>


              <div className="progressbar-form-belt" style={{ left: ('-' + this.state.activeTabIndex + '00%') }}>
                {control.children.map((tab, i) => {
                  return (
                    <div key={tab.id} hidden={IsComplete} className={'progressbar-form ' + (this.state.activeTabIndex == i ? 'active-form' : 'deactivate-form')} id={tab.key} role="tabpanel">
                      <div className="row">
                        <div className="col-md-12">
                          {tab.label ? <h4 className="text-primary">{tab.label}</h4> : ''}
                          {!control.enablestepvalidation ?
                            <div className="row mb-3" >
                              {
                                tab.children.map((ch) => {
                                  return (
                                    ControlService().renderControls(ch, action, formid)
                                  )
                                })
                              }
                            </div>
                            : activeTabIndex == i ?
                              <div className="row mb-3">
                                {
                                  tab.children.map((ch) => {
                                    return (
                                      ControlService().renderControls(ch, action, formid)
                                    )
                                  })
                                }
                              </div>
                              : null}
                          {control.buttonplacing != 'top' && nextBackButton()}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>

            :
            <div className={"wizard wizard-" + control.position + " wizard-not-left"}>
              {(control.position == 'top' && action == 'write') &&
                <div className={"mb-3 d-flex justify-content-center  " + (control.navbg ? control.navbg : 'bg-grey-2')}>
                  <ul className={"d-flex wizard-ul wizard-" + control.position + "-ul"} role="tablist">
                    {wizardnawitems}
                  </ul>
                </div>
              }
              <div className="row">
                {control.position == 'sidebar' &&
                  <div className={"col-sm-12 col-md-3 py-2 px-0 " + (control.navbg ? control.navbg : 'bg-light')}>
                    <ul className={"nav flex-column " + (control.navalign ? control.navalign : 'nav-fill') + " " + control.navbg + " wizard-" + control.position + "-ul"} role="tablist">
                      {wizardnawitems}
                    </ul>
                  </div>
                }
                <div className={"col-sm-12 " + (control.position == 'sidebar' && " col-md-8")}>
                  <form role="form">
                    <div className="tab-content">
                      {
                        control.children.map((tab, i) => {
                          return (
                            <div hidden={IsComplete} className={this.GetClass(i)} id="id" role="tabpanel">
                              <div className="row">
                                <div className="col-md-12">
                                  {(activeTabIndex == i && control.buttonplacing == 'top') && nextBackButton()}
                                  {tab.label ? <h4 className="text-primary">{tab.label}</h4> : ''}
                                  {!control.enablestepvalidation ?
                                    <div className="row mb-3" style={{ 'display': activeTabIndex == i ? '' : 'none' }}>
                                      {
                                        tab.children.map((ch) => {
                                          return (
                                            ControlService().renderControls(ch, action, formid)
                                          )
                                        })
                                      }
                                    </div>
                                    : activeTabIndex == i ?
                                      <div className="row mb-3">
                                        {
                                          tab.children.map((ch) => {
                                            return (
                                              ControlService().renderControls(ch, action, formid)
                                            )
                                          })
                                        }
                                      </div>
                                      : null}
                                  {(activeTabIndex == i && control.buttonplacing != 'top') && nextBackButton()}
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  </form>
                </div>
              </div>
              {(control.position == 'bottom' && action == 'write') &&
                <div className={"mb-3 d-flex justify-content-center  " + (control.navbg ? control.navbg : 'bg-grey-2')}>
                  <ul className={"d-flex wizard-ul"} role="tablist">
                    {wizardnawitems}
                  </ul>
                </div>
              }
            </div>
        }

      </React.Fragment>
    );
  }
}

export default connect(
  mapStateToProps, bindAction
)(FormWizard);